<template>
  <vbt-error-boundary
    :error="$attrs.error"
    :no-content="!items.length"
  >
    <vbt-table
      :headers="headers"
      :items="items"
      show-paginator
    >
      <template #status="{ item: { status } }">
        <kernel-status-badge :status="orderItemStatusEnumByValue[status]">
          {{ status }}
        </kernel-status-badge>
      </template>
      <template #validationStatus="{ item: { validationStatus } }">
        <kernel-status-badge :status="validationStatusEnumByValue[validationStatus]">
          {{ validationStatus }}
        </kernel-status-badge>
      </template>
      <template #flags="{ item }">
        <v-layout column>
          <v-layout>
            Sides: {{ (item.sides || []).length }}
          </v-layout>
          <v-layout>
            SLA Priority: {{ item.slaPriority || '-' }}
          </v-layout>
        </v-layout>
      </template>
      <template #attributes="{ item }">
        <kernel-order-item-attributes-view
          :item="item"
          :order-items="items"
        />
      </template>
    </vbt-table>
  </vbt-error-boundary>
</template>

<script>
import { mapGetters } from 'vuex';

import { namespace as EnumsNamespace } from '@store/modules/enums.types';

import KernelOrderItemAttributesView from './KernelOrderItemAttributesView.vue';

const headers = Object.freeze([
  { text: 'Status', value: 'status' },
  { text: 'Validation', value: 'validationStatus' },
  { text: 'Order Item ID', value: 'outerId' },
  { text: 'Flags', value: 'flags' },
  { text: 'Attributes', value: 'attributes' },
  { text: 'Product Type', value: 'productType' },
  { text: 'Quantity', value: 'quantity' },
]);

export default {
  name: 'KernelOrderItemsList',
  components: {
    KernelOrderItemAttributesView,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({ headers }),
  computed: {
    ...mapGetters(EnumsNamespace, ['orderItemStatusEnumByValue', 'validationStatusEnumByValue']),
  },
};
</script>
